import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCardFill = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M19.25 4H4.75C4.02106 4.00132 3.32236 4.29148 2.80692 4.80692C2.29148 5.32236 2.00132 6.02106 2 6.75V17.25C2.00132 17.9789 2.29148 18.6776 2.80692 19.1931C3.32236 19.7085 4.02106 19.9987 4.75 20H19.25C19.9789 19.9987 20.6776 19.7085 21.1931 19.1931C21.7085 18.6776 21.9987 17.9789 22 17.25V6.75C21.9987 6.02106 21.7085 5.32236 21.1931 4.80692C20.6776 4.29148 19.9789 4.00132 19.25 4ZM20.5 17.25C20.5 17.94 19.94 18.5 19.25 18.5H4.75C4.06 18.5 3.5 17.94 3.5 17.25V10.5H20.5V17.25ZM20.5 8.5H3.5V6.75C3.5 6.06 4.06 5.5 4.75 5.5H19.25C19.94 5.5 20.5 6.06 20.5 6.75V8.5Z",
		fill: "white"
	})
});
const ForwardRef = forwardRef(SvgCardFill);
export default ForwardRef;
